import { ValidShipOrder } from '../ValidShipOrder';

export class RoutePlanTransportSegment {
  /**
   * The id of the ship order this `RoutePlanTransportSegment` represents
   *
   * This field is only available if the model came from the backend. Otherwise,
   * it will be `undefined` and `shipOrder` will be populated instead.
   */
  _shipOrderId?: number;
  shipOrder?: ValidShipOrder;
  pickupStopSequenceNumber?: number;
  dropOffStopSequenceNumber?: number;

  constructor(opts?: Partial<RoutePlanTransportSegment>) {
    if (opts?.shipOrder) {
      this.shipOrder = new ValidShipOrder(opts.shipOrder);
    } else if (opts?.shipOrderId) {
      this._shipOrderId = opts.shipOrderId;
    } else {
      throw new Error(
        'Either `shipOrder` or `shipOrderId` must be provided to initialize a `RoutePlanTransportSegment`',
      );
    }

    if (opts?.pickupStopSequenceNumber) {
      this.pickupStopSequenceNumber = opts.pickupStopSequenceNumber;
    }

    if (opts?.dropOffStopSequenceNumber) {
      this.dropOffStopSequenceNumber = opts.dropOffStopSequenceNumber;
    }
  }

  get shipOrderId() {
    // The -1 should never be returned; One of _shipOrderId or shipOrder should be defined
    return this._shipOrderId ?? this.shipOrder?.id ?? -1;
  }

  toJSON() {
    return {
      shipOrderId: this.shipOrderId,
      pickupStopSequenceNumber: this.pickupStopSequenceNumber,
      dropOffStopSequenceNumber: this.dropOffStopSequenceNumber,
    };
  }
}
